
import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({
})
export default class DexMobileModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  public isModalClosed: boolean = false;
 
  public closeModal(isCreated: boolean) {
    this.isModalClosed = true;
    this.$emit("close-modal", isCreated);
  }

  
}
